import { GenIcon } from 'react-icons';
export const MdBankIdentityFilled = GenIcon({
    tag: 'svg',
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        fill: 'none',
    },
    child: [
        {
            tag: 'path',
            attr: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'M14.4233 5.00959C19.4808 5.00959 22 8.7524 22 12.5048C22 16.2476 19.4808 20 14.4233 20H8.76498V5.00959H14.4233ZM6.20704 8.96617V20H3V8.96617H6.20704ZM14.3168 7.89688H10.7899V8.96617H12.2821V16.0434H10.7899V17.1127H14.3168C17.0974 17.1127 18.4829 14.8185 18.4829 12.5048C18.4829 10.2106 17.0974 7.89688 14.3168 7.89688ZM6.20704 5V7.89688H3V5H6.20704Z',
                fill: 'currentColor',
            },
            child: [],
        },
    ],
});
